import React, { useLayoutEffect, useMemo } from "react";
import classNames from "classnames";
import "../styles/switch-tabs.scss";
import {
  __INTERNAL_APP_NAME__DECCAN,
  __INTERNAL_APP_NAME__PRAJAVANI,
  email_tab_indetifier,
  mobile_tab_indetifier,
} from "../contant";
import { useLocation } from "react-router-dom";
import selected_tab_icon_deccan from "../images/selected_tab_icon_deccan.svg";
import selected_tab_icon_prajavani from "../images/selected_tab_icon_prajavani.svg";
import useInternalAppName from "../hooks/useInternalAppName";

const SwitchTabs = ({
  data,
  setTab,
  setInputError,
  className,
  tab: stateTab,
}) => {
  const { appName: internalAppName } = useInternalAppName();

  // IDEALLY, this should not have been existed at all
  // but we cannot put condition of active tab name (stateTab or tab coming from prop)
  const currentSelectedTabIdentifier = useMemo(() => {
    return data.find((item) => stateTab === item.tabName)?.tabIdentifier;
  }, [data, stateTab]);

  const activeTab = (tab) => {
    setTab(tab.tabName);
    setInputError("");
  };

  const location = useLocation();

  useLayoutEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    const newSelectedTabBasedUponUrlParam = data.find(
      (item) => item?.tabIdentifier === urlSearchParams.get("selectedTab")
    )?.tabName;
    if (newSelectedTabBasedUponUrlParam) {
      setTab(newSelectedTabBasedUponUrlParam);
    }
  }, []);

  const selectedTabIcon = useMemo(() => {
    const iconMap = new Map([
      [__INTERNAL_APP_NAME__DECCAN, selected_tab_icon_deccan],
      [__INTERNAL_APP_NAME__PRAJAVANI, selected_tab_icon_prajavani],
    ]);

    return iconMap.get(internalAppName) || selected_tab_icon_deccan;
  }, [internalAppName]);

  return (
    <div className="switching-tabs bg-gray-200 p-1 flex justify-center">
      <div className="flex relative items-center tabItems">
        {data.map((tab) => (
          <button
            key={tab.tabIdentifier}
            className={`flex border-none bg-transparent justify-center items-center relative cursor-pointer h-full text-base z-10 tabItem disabled:pointer-events-none ${
              stateTab === tab.tabName
                ? `active text-gray-800 font-bold font-notoSans ${className}`
                : "text-gray-600"
            }`}
            onClick={() => activeTab(tab)}
            type="button"
          >
            {/**
             * TODO:
             * Any individual app name checks are not ideal
             * any condition should based upon a mapper only
             * for e.g. if we add new app, then this will be
             * a problem and we will have to change condition at every
             * component
             * instead we have a mapper which itself will return the name of thw image or the image itself
             * that will be a proper solution
             */}
            {stateTab === tab.tabName && (
              <img
                src={selectedTabIcon}
                alt="selected tab"
                className={classNames("size-6 animate-fade-in transition-all")}
              />
            )}
            &nbsp;
            <img src={tab.tabLogo} alt="smartphone-line" className="pr-1" />
            {tab.tabName}
          </button>
        ))}
        <span
          className={classNames(`movingBg bg-white absolute`, {
            "left-0": currentSelectedTabIdentifier === mobile_tab_indetifier,
            "left-[140px]":
              currentSelectedTabIdentifier === email_tab_indetifier,
            "movingBg-border-prajavani":
              internalAppName === __INTERNAL_APP_NAME__PRAJAVANI,
            "movingBg-border-deccan":
              internalAppName === __INTERNAL_APP_NAME__DECCAN,
          })}
        />
      </div>
    </div>
  );
};

export default SwitchTabs;
